import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {User} from '../../models/user';
import {AuthService} from '../../services/auth.service';
import {filter, finalize, Subject, takeUntil} from 'rxjs';
import {MembershipService} from '../../services/membership.service';
import {Membership} from '../../models/membership';

@Component({
  selector: 'app-settings',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    NgIf,
    NgSwitch,
    NgSwitchDefault,
    NgSwitchCase
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  // Route
  currentPath: string = '/settings';

  // User
  currentUser: User | null = null;

  // Membership
  isMembershipLoading = false
  isMembershipLoaded = false
  membership: Membership | null = null

  // Membership calculation
  isMembershipAllowedExtraHours = false

  constructor(private router: Router,
              private authService: AuthService,
              private membershipService: MembershipService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;

        // Redirect the customer to the membership reactivation page if customer doesn't have membership
        if (currentUser.role === 'customer') {
          this.refreshCurrentMembership();
        }
      }
    });

    this.currentPath = this.router.url
    this.router.events.pipe(
      takeUntil(this.onDestroy$),
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentPath = event.url;
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  refreshCurrentMembership() {
    this.isMembershipLoading = true
    this.membershipService.getCurrentByUser().pipe(
      takeUntil(this.onDestroy$),
      finalize(() => {
        this.isMembershipLoading = false;
        this.isMembershipLoaded = true
      })).subscribe({
      next: (membership) => {
        this.membership = membership;
        this.calculateMembership()
      }, error: () => {
        this.router.navigate(['/settings', 'membership']).finally();
      }
    })
  }

  calculateMembership() {
    if (!this.membership) {
      return;
    }

    this.isMembershipAllowedExtraHours = ['raspberry', 'strawberry', 'blueberry', 'plain'].indexOf(this.membership.product.membershipProperties.code) !== -1
  }

}
